// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Pjd7","footer":"ModalInfo_footer__1cH0N"};